define('bootstrapping/viewLocatorTask',['durandal/viewLocator'], function (viewLocator) {

    return {
        execute: function () {
            viewLocator.useConvention();
        }
    };

});
